import * as React from "react"
const SchoolIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={800}
    height={800}
    aria-hidden="true"
    viewBox="0 0 14 14"
    {...props}
  >
    <path d="M12.5 12.255a.32.32 0 0 0 .313-.387l-.202-.957a.61.61 0 0 0-.02-.895V6.694l-.81.501v2.82a.609.609 0 0 0-.02.896l-.201.957a.321.321 0 0 0 .314.387h.625zm.274-7.5L7.502 1.492a.957.957 0 0 0-1.004 0L1.226 4.755a.478.478 0 0 0 0 .814l5.272 3.263a.951.951 0 0 0 1.004 0l5.272-3.263a.478.478 0 0 0 0-.814zM7 9.785c-.329 0-.65-.091-.929-.264L2.996 7.617v3.278c0 .97 1.794 1.756 4.004 1.756 2.21 0 4.003-.786 4.003-1.756V7.617L7.93 9.521c-.28.173-.601.264-.93.264Z" />
  </svg>
)
export default SchoolIcon
